/* eslint-disable no-unused-vars */
import React, { useMemo } from 'react'
import classNames from 'classnames'
import { useNavigate, NavigateFunction } from 'react-router-dom'

import { ConditionalWrapper } from '@/components'
import { useApp } from '@/hooks'
import { IMenu } from '@/types'
import { t } from '@/i18n'

interface Props {
  isBTN?: boolean
  buttonText: string
  wrapperClassName?: string
  buttonClassName?: string
  leftIcon?: React.ReactNode
  rightIcon?: React.ReactNode
  placement?: 'top' | 'bottom'
  menus: IMenu[]
  onClickLink?: (link: string, name: string) => void
}

const DropButton: React.FC<Props> = ({
  menus,
  buttonText,
  buttonClassName,
  leftIcon,
  rightIcon,
  wrapperClassName,
  isBTN = true,
  placement = 'bottom',
  onClickLink,
}) => {
  const { isRTL, me } = useApp()
  const navigate: NavigateFunction = useNavigate()

  const _menus = useMemo(() => {
    return menus.filter(m => {
      if (m.role?.length) {
        if (me) {
          return m.role.includes('superuser') ? Boolean(me.isSuperuser) : true
        } else {
          return false
        }
      }
      return true
    })
  }, [me, menus])

  const Component = isBTN ? 'button' : 'a'
  const _className = classNames(buttonClassName, {
    rtlMeuBtn: Boolean(isRTL),
  })

  return (
    <div className={classNames(wrapperClassName || 'drop-btn', placement)}>
      <ConditionalWrapper
        Wrapper={'div'}
        condition={!isBTN}
        wrapperClassName={_className}
      >
        <Component className={isBTN ? _className : ''}>
          {leftIcon}
          {buttonText}
          {rightIcon}
        </Component>
      </ConditionalWrapper>
      {_menus.length > 0 && (
        <div
          className={classNames('drop-item', {
            rtlDropItem: Boolean(isRTL),
          })}
        >
          <ul>
            {_menus.map(menu => (
              <li key={menu.id}>
                <a
                  href={undefined}
                  onClick={e => {
                    e.preventDefault()
                    onClickLink
                      ? onClickLink(menu.path, menu.name)
                      : navigate(menu.path)
                  }}
                >
                  {!!menu.icon && <span className={menu.icon} />}
                  {!!menu.image && <img src={menu.image} />}
                  {t(menu.name)}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  )
}

export default DropButton
